import React from 'react'

import notFoundImage from '../../assets/imgs/404.png';
export default function NotFoundPage() {
  return (
    <div className="mt-[65px] sm:h-[580px] h-[400px]text-white flex flex-col items-center justify-center">
      <img src={notFoundImage} className="w-[300px] h-[300px]" />
    </div>
  )
}
